export const GLOBAL_CLASSES = {
  kioskApp: 'is-kiosk-app',
  pageLongContent: 'long-content'
};
